import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { getAdvanced } from '../../utils';
export default (function (node) {
  return _objectSpread({
    richContent: node.childNodes[0] ? node.childNodes[0].innerHTML : ''
  }, getAdvanced(node));
});